import PropTypes from 'prop-types';
import React, { useState } from 'react';
import constants from '../../config/constants';
import { noop } from '../../utils/noop';
import MatchMedia from '../ui/MatchMedia/MatchMedia';
import TypeAVariantDesktop from './Desktop/TypeAVariantDesktop';
import TypeAVariantMobile from './Mobile/TypeAVariantMobile';

const TypeAVariant = ({
  brandName,
  variantName,
  variantId,
  prices,
  addToCart,
  isHomeDeliveryAvailable,
  isPickFromStoreAvailable,
  offeringId,
  maxOnCartAmount,
  stockUnits,
}) => {
  const [productCount, setProductCount] = useState(1);

  const incrementCount = () => setProductCount(productCount + 1);
  const decrementCount = () => setProductCount(productCount - 1);

  const maxOnLimitCart = (networkStock, limit) => {
    if (typeof networkStock !== 'number') {
      return limit;
    }
    return networkStock > limit ? limit : networkStock;
  };

  const handleAddToCart = () => {
    addToCart({ skuId: variantId, quantity: productCount, offeringId });
  };

  const networkStock = stockUnits[variantId];
  const limit = maxOnCartAmount || constants.MAX_CART_PRODUCT;

  const maxForStepper = maxOnLimitCart(networkStock, limit) + 1;

  const showAlert = !!(productCount > maxOnLimitCart(networkStock, limit));

  const typeAVariantProps = {
    variantName,
    brandName,
    prices,
    isHomeDeliveryAvailable,
    isPickFromStoreAvailable,
    addToCart: handleAddToCart,
    variantId,
    count: productCount,
    incrementCount,
    decrementCount,
    maxForStepper,
    showAlert,
  };

  return (
    <MatchMedia
      content={{
        desktop: () => <TypeAVariantDesktop {...typeAVariantProps} />,
        mobile: () => <TypeAVariantMobile {...typeAVariantProps} />,
        tablet: () => <TypeAVariantDesktop {...typeAVariantProps} />,
      }}
    />
  );
};

TypeAVariant.defaultProps = {
  brandName: '',
  prices: [],
  addToCart: noop,
  isHomeDeliveryAvailable: false,
  isPickFromStoreAvailable: false,
  offeringId: '',
  maxOnCartAmount: 0,
  stockUnits: [],
};

TypeAVariant.propTypes = {
  brandName: PropTypes.string,
  variantName: PropTypes.string.isRequired,
  variantId: PropTypes.string.isRequired,
  prices: PropTypes.arrayOf(PropTypes.object),
  addToCart: PropTypes.func,
  isHomeDeliveryAvailable: PropTypes.bool,
  isPickFromStoreAvailable: PropTypes.bool,
  offeringId: PropTypes.string,
  maxOnCartAmount: PropTypes.number,
  stockUnits: PropTypes.arrayOf(PropTypes.object),
};

export default TypeAVariant;
